import _, {keyBy} from 'lodash';

import {AppAction} from '../../../appActions';
import {ResourceMap} from '../../../appTypes';
import {BannersActionsEnum} from './bannersActions';
import {BannerState, BannerTypesEnum} from './bannersState';

export function bannersReducer(state: ResourceMap<BannerState>, action: AppAction) {
  if (action.type !== BannersActionsEnum.UPDATE_BANNERS) {
    return state;
  }

  return {
    ...state,
    ...keyBy(action.payload.bannersToAdd, (b) => b.uid),
  };
}

export function visibleBannerUidsReducer(state: ReadonlyArray<string>, action: AppAction) {
  if (action.type !== BannersActionsEnum.UPDATE_BANNERS) {
    return state;
  }

  const {bannersToAdd, visibleBannerUidsToRemove} = action.payload;
  const bannerUidsToAdd = bannersToAdd && bannersToAdd.map((b) => b.uid);

  return _(state)
    .concat(bannerUidsToAdd || [])
    .difference(visibleBannerUidsToRemove || [])
    .uniq()
    .value();
}

export function undoBannerUidsReducer(state: ReadonlyArray<string>, action: AppAction) {
  if (action.type !== BannersActionsEnum.UPDATE_BANNERS) {
    return state;
  }

  const {bannersToAdd, undoBannerUidsToRemove} = action.payload;
  const bannerUidsToAdd = _(bannersToAdd)
    .filter((b) => b.type === BannerTypesEnum.UNDO)
    .map((b) => b.uid)
    .value();

  return _(state)
    .concat(bannerUidsToAdd)
    .difference(undoBannerUidsToRemove || [])
    .uniq()
    .value();
}

export function errorBannerUidsReducer(state: ReadonlyArray<string>, action: AppAction) {
  if (action.type !== BannersActionsEnum.UPDATE_BANNERS) {
    return state;
  }

  const {bannersToAdd, errorBannerUidsToRemove} = action.payload;
  const bannerUidsToAdd = _(bannersToAdd)
    .filter((b) => b.type === BannerTypesEnum.ERROR)
    .map((b) => b.uid)
    .value();

  return _(state)
    .concat(bannerUidsToAdd)
    .difference(errorBannerUidsToRemove || [])
    .uniq()
    .value();
}
